import {
    Injectable
} from '@angular/core';

import {
    DigitalPaymentHandler,
    DigitalPaymentHandlerOptions,
    DigitalPaymentHandlerResult
} from 'src/app/shared/model/digital-payments.model';

import {
    SalesPayments,
} from 'tilby-models';

import {
    ZPaySoftPOS
} from './zpay-softpos.model';

@Injectable({
    providedIn: 'root'
})
export class ZPaySoftPOSService implements DigitalPaymentHandler {
    getPaymentReceipt?(paymentMethod: SalesPayments): string {
        return '';
    }

    //Promise wrappers for cordova methods
    private setEnvironent = (environment: 'STAGING' | 'PRODUCTION') => new Promise((resolve, reject) => window.ZpaySoftpos.setEnvironment(environment, resolve, reject));
    private isConnected = () => new Promise<boolean>((resolve, reject) => window.ZpaySoftpos.isConnected(resolve, reject));
    private connect = (publicKey: string, terminalId: string) => new Promise((resolve, reject) => window.ZpaySoftpos.connect(publicKey, terminalId, resolve, reject));
    private logout = () => new Promise((resolve, reject) => window.ZpaySoftpos.logout(resolve, reject));
    private charge = (amount: number, description: string) => new Promise<string>((resolve, reject) => window.ZpaySoftpos.charge(amount, description, resolve, reject));
    private getPublicKey = () => new Promise<string>((resolve, reject) => window.ZpaySoftpos.getPublicKey(resolve, reject));
    private getTerminalId = () => new Promise<string>((resolve, reject) => window.ZpaySoftpos.getTerminalId(resolve, reject));
    private getPaymentCharge = (chargeToken: string) => new Promise<ZPaySoftPOS.PaymentTransaction>((resolve, reject) => window.ZpaySoftpos.getPaymentCharge(chargeToken, resolve, reject));
    private isInstalled = () => new Promise((resolve, reject) => window.ZpaySoftpos.isInstalled(resolve, reject));

    async payment(amount: number, options: DigitalPaymentHandlerOptions): Promise<DigitalPaymentHandlerResult> {
        const isInstalled = await this.isInstalled()
            .then(res => !!res)
            .catch(() => false);

        if(!isInstalled) {
            await this.logout().catch(() => {});
            throw 'DIGITAL_PAYMENTS.ZPAY_SOFTPOS.NOT_INSTALLED';
        }

        const isConnected = await this.isConnected();

        const paymentConfiguration = options.paymentMethod.configuration;

        if(!paymentConfiguration?.publicKey) {
            throw 'DIGITAL_PAYMENTS.ZPAY_SOFTPOS.MISSING_PUBLIC_KEY';
        }

        if(!paymentConfiguration?.terminalId) {
            throw 'DIGITAL_PAYMENTS.ZPAY_SOFTPOS.MISSING_TERMINAL_ID';
        }

        await this.setEnvironent(paymentConfiguration.stagingMode ? 'STAGING' : 'PRODUCTION');

        let needsConnection = !isConnected;

        if(!needsConnection) {
            const publicKey = await this.getPublicKey();
            const terminalId = await this.getTerminalId();

            needsConnection = publicKey !== paymentConfiguration.publicKey || terminalId !== paymentConfiguration.terminalId;
        }

        if (needsConnection) {
            await this.logout().catch(() => {});
            await this.connect(paymentConfiguration.publicKey, paymentConfiguration.terminalId);
        }

        const chargeToken = await this.charge(amount, options.sale.name);

        const paymentCharge = await this.getPaymentCharge(chargeToken);

        if(paymentCharge.status !== 'SUCCEEDED') {
            throw new Error(paymentCharge.errorMessage || paymentCharge.error || 'Unknown error');
        }

        return {
            payment_data: JSON.stringify(paymentCharge),
            unclaimed: false
        }
    }
}